import { createSlice } from '@reduxjs/toolkit';

import { Contact } from '@/types/contact';
import * as asyncActions from './asyncActions';

type State = {
  items: Contact[];
};

const initialState: State = {
  items: [],
};

const slice = createSlice({
  name: 'organization-billing-contact',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(asyncActions.fetchAll.fulfilled, (state, action) => {
      state.items = action.payload;
    });
  },
});

export const actions = slice.actions;
export default slice.reducer;
